'use client';

import { useColorScheme } from '@contexts/ColorSchemeContext';
import c from 'classnames';
import { Moon } from 'phosphor-icons';
import { useId } from 'react';
import { Switch } from 'ui-components';

type UserMenuDarkModeSwitchProps = {
  label: string;
  className?: string;
};

export const UserMenuDarkModeSwitch = ({
  label,
  className = '',
}: UserMenuDarkModeSwitchProps) => {
  const { isDarkMode, setDarkMode } = useColorScheme();
  const labelId = useId();

  return (
    <div
      data-test="user-menu-dark-mode"
      className={c(
        'flex items-center justify-between gap-4 lg:px-4',
        className
      )}
    >
      <span id={labelId} className="flex items-center text-white">
        <Moon aria-hidden size={20} className="mr-2 fill-grey-400" />
        {label}
      </span>
      <Switch
        checked={isDarkMode}
        onCheckedChange={setDarkMode}
        ariaLabelledBy={labelId}
        testId="user-menu-dark-mode-switch"
      />
    </div>
  );
};
